module.exports = __webpack_public_path__ + "img/shopping.45f9a38e.svg";